import React, { useCallback, useEffect, useState } from "react";
import { Chip, Divider, Grid, Tooltip } from "@mui/material";
import { getPatientMedications } from "app/services/transmission/patient-medication";
import Loading from "components/common/loading/Loading";
import { showToast } from "utils/toast";

const MedicationInfo = ({ patientId }) => {
  const [medicationList, setMedicationList] = useState([]);
  const [isFetching, setIsFetching] = useState([]);

  const mapMedicationData = useCallback((medicationData) => {
    const medicationList = medicationData.map((medData) => ({
      medicine_information: medData.medicine_information,
      medicine_start_date: medData.medicine_start_date,
      medicine_end_date: medData.medicine_end_date,
      active: medData.active,
    }));

    setMedicationList(medicationList);
  }, []);

  const fetchMedicationList = useCallback(
    async (patientId) => {
      try {
        setIsFetching(true);
        const result = await getPatientMedications(patientId);
        const medicationData = result?.data?.medications || [];
        if (medicationData.length > 0) {
          mapMedicationData(medicationData);
        }
      } catch (error) {
        showToast({ message: error.message, type: "error" });
      } finally {
        setIsFetching(false);
      }
    },
    [mapMedicationData]
  );

  useEffect(() => {
    if (patientId) {
      fetchMedicationList(patientId);
    }
  }, [fetchMedicationList, patientId]);

  const renderMedicationInformationPreview = () => {
    if (isFetching) {
      return <Loading height="50px" />;
    }

    if (medicationList.length === 0) {
      return <span>No medication information found.</span>;
    }

    return medicationList.map((data, index) => {
      const {
        medicine_information,
        medicine_start_date,
        medicine_end_date,
        active,
      } = data;

      const numbering = index + 1;

      return (
        <>
          <Grid container xs={8}>
            <Grid
              key={`medication_data_${numbering}`}
              container
              rowSpacing={1}
              className="medication-information__list"
            >
              <Grid item xs={1}>
                <span className="medication-information__numbering mr-2">
                  {numbering}.
                </span>
              </Grid>
              <Grid item xs={8}>
                <Tooltip title={medicine_information}>
                  <div className="medication-information__preview-text">
                    <span>{medicine_information}</span>
                  </div>
                </Tooltip>
              </Grid>
            </Grid>
            <Grid
              key="medication_data_index"
              container
              rowSpacing={1}
              className="medication-information__list"
            >
              <Grid item xs={1} />
              <Grid item xs={11}>
                <span className="medication-date-info">
                  {medicine_start_date}
                  {medicine_end_date && ` - ${medicine_end_date}`}
                </span>
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={4} className="medication_data-chip-grid">
            <Chip
              label={active ? "Active" : "Inactive"}
              size="small"
              className={`ml-2 medication-information__chip_${
                active ? "active" : "inactive"
              }`}
            />
          </Grid>
        </>
      );
    });
  };

  return (
    <>
      <Divider />
      <div className="view-pdf__drawer--header">Medication Info</div>
      <Grid container>{renderMedicationInformationPreview()}</Grid>
    </>
  );
};

export default MedicationInfo;
